import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { GooglePhotosIcon } from '../SourceIcon/Icons';
import styles from './GooglePhotoButton.scss';
import { IInner, IOuter } from './GooglePhotoButton.types';

export const GooglePhotoButton: FC<IOuter & IInner> = ({ onClick }) => (
  <button className={styles.googlePhotoButton} onClick={onClick} data-hook="connect-external-source-button">
    <div className={styles.iconHolder}>
      <GooglePhotosIcon />
    </div>

    <div className={styles.buttonText}>
      <FormattedMessage
        id="files-importer.connect-source.connect"
        values={{ sourceName: <FormattedMessage id="files-source.label.google-photos" /> }}
      />
    </div>
  </button>
);
